
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/affiliate/profile",
      function () {
        return require("private-next-pages/affiliate/profile.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/affiliate/profile"])
      });
    }
  